/*
 * @Author: liuxw@codoon.com
 * @Date: 2021-07-16 10:47:21
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-16 13:50:37
 * @Content: 报名后活动奖励模块
 */

import React, { FC, memo, useCallback, useMemo } from "react";
import { IMedalInfo, IPostCreateTempDetail } from "../../../service/Index";
import SignRewardModule from "../SignRewardModule";
import "./index.less";

const PREFIX = "ProgressRewardModule";

type IProps = {
  tempDetail: IPostCreateTempDetail;
  completeCount: number;
  // 自动拉取奖章才有
  medals: IMedalInfo[];
};

const ProgressRewardModule: FC<IProps> = memo(
  ({ tempDetail, completeCount, medals }) => {
    const progressRewardInfo = useMemo(() => {
      return tempDetail.reword_list;
    }, [tempDetail]);

    /* 渲染奖章 */
    const renderMedalItem = useCallback((medal: IMedalInfo) => {
      return (
        <div className={`${PREFIX}-mainMedalItem`} key={medal.code}>
          <div className={`${PREFIX}-mainMedalItemImg`}>
            <img src={medal.img} />
          </div>
          <div className={`${PREFIX}-mainMedalItemInfo`}>
            <div className={`${PREFIX}-mainMedalItemInfoName`}>
              {medal.name}
            </div>
          </div>
        </div>
      );
    }, []);

    /* 渲染模块主体部分 */
    const renderBody = useCallback(() => {
      if (progressRewardInfo.reward_type === "sync_with_sign_page") {
        // 与报名页同步
        return <SignRewardModule tempDetail={tempDetail} />;
      } else if (progressRewardInfo.reward_type === "medal") {
        // 自动拉取奖章
        return (
          <div className={`${PREFIX}-main`}>
            <div className={`${PREFIX}-mainTitle`}>·活动奖励·</div>
            <div className={`${PREFIX}-mainMedal`}>
              {medals
                ? medals.map((medal) => {
                    return renderMedalItem(medal);
                  })
                : null}
            </div>
          </div>
        );
      } else {
        return (
          <div className={`${PREFIX}-main`}>
            <div className={`${PREFIX}-mainTitle`}>·活动奖励·</div>
          </div>
        );
      }
    }, [progressRewardInfo, tempDetail]);

    if (!progressRewardInfo.show) {
      return null;
    } else {
      return (
        <div className={PREFIX}>
          {renderBody()}
          <div className={`${PREFIX}-complete`}>
            {completeCount
              ? `截至目前已有${completeCount}人完成挑战`
              : `加油成为第一个完成挑战的人吧！`}
          </div>
        </div>
      );
    }
  }
);

export default ProgressRewardModule;
